import Cookies from 'js-cookie';

/**
 * @see https://github.com/alfhen/vue-cookie
 * @see https://github.com/cmp-cc/vue-cookies
 */
export default {
    methods: {
        getCookie(name) {
            return Cookies.get(name);
        },

        setCookie(name, value, expires) {
            return Cookies.set(name, value, {
                expires: expires
            });
        }
    }
};
